import { CommonTooltips } from "@mcleod/common";
import { ChangeEvent, DropdownSelectionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { Model, ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommUnitChangeConfirmation } from "./autogen/AutogenLayoutMobileCommUnitChangeConfirmation";

export class MobileCommUnitChangeConfirmation extends AutogenLayoutMobileCommUnitChangeConfirmation {
    private payrollControl: ModelRow;

    async onLoad(): Promise<void> {
        this.addLayoutLoadListener(() => {
            this.textboxUnitType.selectedItem = this.textboxUnitType.resolveItems()[0];
        });
    }

    textboxUnitNumberBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.mc_unit_type = this.textboxUnitType.selectedItem.value;
    }

    textboxUnitTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.textboxUnitNumber.clear();
    }
}
